'use client';

import { useUi } from '@weareconceptstudio/core';

//* Styles
import Variables from '@/styles/variables';
import Typography from '@/styles/typography';
import HelperClass from '@/styles/helperClass';


const GlobalStyle = () => {
    const { isBurgerMenuOpen, popupIsOpen } = useUi();

    return (
        <>
            <Variables />
            <HelperClass />
            <Typography
                $popupIsOpen={popupIsOpen}
                $isBurgerMenuOpen={isBurgerMenuOpen}
            />
        </>
    )
}

export default GlobalStyle;